import React from "react";
import { Leaf } from "lucide-react";

const ITEMS = [
  "✦ Homemade",
  "✦ Gluten Free",
  "✦ Homemade",
  "✦ Gluten Free",
  "✦ Homemade",
  "✦ Gluten Free",
  "✦ Homemade",
  "✦ Gluten Free",
  "✦ Homemade",
  "✦ Gluten Free",
  "✦ Homemade",
  "✦ Gluten Free",
];

export default function Ribbon() {
  return (
    <div className="w-full overflow-hidden bg-sage-600 py-2.5 select-none">
      <div className="marquee-track animate-marquee">
        {/* Duplicate for seamless loop */}
        {[...ITEMS, ...ITEMS].map((text, i) => (
          <span
            key={i}
            className="inline-flex items-center gap-3 px-6 font-body text-sm tracking-widest uppercase text-white/90 font-bold"
          >
            {text}
          </span>
        ))}
      </div>
    </div>
  );
}
